import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface LoginParams {
  email: string;
  password: string;
  isRemember: boolean;
}

export interface LoginState {
  errorMessage: string;
  isOtpRequired: boolean;
  isTotpMode: boolean;
  isCountDownStarted: boolean;
  isDeviceRecognized: boolean;
  isLoading: boolean;
  resendDelaySeconds?: number;
  twoFactorAuthMethod?: 'OTP' | 'TOTP' | string | null;
}

@Injectable()
export abstract class LoginStoreFactory {
  abstract vm$: Observable<LoginState>;
  abstract login(params: LoginParams): void;
  abstract disableOtpRequire(): void;
  abstract checkAccessToken(): void;
  abstract checkStoredFingerprint(email: string): void;
  abstract getFingerPrintId(email: string): string;
  abstract resetDeviceRecognition(): void;
  abstract setResendDelaySeconds(seconds: number): void;
  abstract checkExistingOtpSession(email: string): boolean;
  abstract resumeOtpSession(): void;
}
